<template>
    <div class="form-group">
        <FormLabel required>職種</FormLabel>
        <div class="flex-1 col-span-8">
            <FormInput :value="value" @input="s => $emit('input', s)"
                       type="select" :options="industryList" class="lg:w-500p"/>
            <ErrorText name="industry" :errors="errors"/>
        </div>
    </div>
</template>

<script>
import SectionLabel from "./SectionLabel";
import FormInput from "../app/FormInput";
import ErrorText from "../ErrorText";
import applicationSelectItem from "../../mixins/applicationSelectItem";
import FormLabel from "./FormLabel";

export default {
    name: "IndustryForm",
    components: {FormLabel, ErrorText, FormInput, SectionLabel},
    mixins: [applicationSelectItem],

    props: {
        value: {
            type: String,
        },
        errors: {
            type: Object | Array,
        }
    },
}
</script>

<style scoped>

</style>
